import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationFR from './locales/fr.json';
import translationHI from './locales/hi.json';
import translationAR from './locales/ar.json';
import translationZH from './locales/zh.json';
import translationDE from './locales/de.json';
import translationTE from './locales/te.json';

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  fr: { translation: translationFR },
  hi: { translation: translationHI },
  ar: { translation: translationAR },
  zh: { translation: translationZH },
  de: { translation: translationDE },
  te: { translation: translationTE }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
